import React from 'react'

const useSkipFirstEffect = (effect: React.EffectCallback, deps: React.DependencyList = []): void => {
    const isFirst = React.useRef(true)

    React.useEffect(() => {
        if (isFirst.current) {
            isFirst.current = false

            return
        }

        return effect()
    }, deps)
}

export default useSkipFirstEffect
